import type { CloseButtonStyleConfig } from 'components/forms/closeButton/types';

const COLOR_SCHEMES = {
  default: {
    color: 'inherit',
  },
  onInteraction: {
    color: 'feature.onInteraction',
  },
} as const;

const baseStyle: CloseButtonStyleConfig['baseStyle'] = ({ colorScheme }) => {
  const schemeColors = COLOR_SCHEMES[colorScheme] ?? COLOR_SCHEMES.default;

  return {
    borderRadius: 'md',
    transition: 'all 0.2s',
    cursor: 'pointer',
    color: schemeColors.color,
    _hover: {
      bg: 'interaction.surfaceHover',
    },
    _active: {
      bg: 'interaction.surfaceActive',
    },
    _focusVisible: {
      boxShadow: 'focus',
    },
    _disabled: {
      bg: 'transparent',
      color: 'interaction.disabled',
      cursor: 'not-allowed',
      boxShadow: 'none',
    },
  };
};

const SIZES = {
  lg: {
    w: 4,
    h: 4,
    fontSize: 'lg',
  },
  md: {
    w: 3.5,
    h: 3.5,
    fontSize: 'md',
  },
  sm: {
    w: 3,
    h: 3,
    fontSize: 'sm',
  },
} as const;

const DEFAULT_PROPS = {
  size: 'md',
  colorScheme: 'default',
} as const;

export const CLOSE_BUTTON_STYLE_CONFIG: CloseButtonStyleConfig = {
  baseStyle,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
};
